import { useMutation, useQueryClient } from "@tanstack/react-query";
import { enqueueSnackbar } from "notistack";
import { apiFetch } from "@core/index";
import { IUpdateInvoicePartiesPayload } from "../utils/types";
import { apiEndpoint } from "../utils/constants";

export const useUpdateInvoiceParty = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (config: { payload: IUpdateInvoicePartiesPayload }) => {
      const { id, payloadData } = config.payload;
      const response = await apiFetch<{
        statusCode: number;
        message: string;
        data?: unknown;
      }>(`${apiEndpoint}/${id}`, {
        method: "PATCH",
        body: payloadData,
      });
      return response;
    },
    onSuccess: () => {
      enqueueSnackbar("Invoice party updated successfully.", {
        variant: "success",
        autoHideDuration: 2000,
      });
      queryClient.invalidateQueries({ queryKey: ["invoiceParties"] });
    },
    onError: (error: Error) => {
      enqueueSnackbar(
        "Failed to update invoice party. Error: " + (error ?? ""),
        {
          variant: "error",
          autoHideDuration: 5000,
        },
      );
    },
  });
};
